
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"5","height":"5","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2.438 4.883c-.454 0-.855-.102-1.204-.305a2.087 2.087 0 01-.796-.836 2.578 2.578 0 01-.282-1.21c0-.443.1-.842.297-1.196C.656.976.937.7 1.297.508 1.657.31 2.063.21 2.516.21c.448 0 .846.099 1.195.297.354.198.628.474.82.828.198.354.297.755.297 1.203 0 .443-.104.844-.312 1.203a2.19 2.19 0 01-.852.836 2.477 2.477 0 01-1.227.305zM2.483.984c-.291 0-.552.068-.78.204-.23.13-.407.312-.532.546a1.684 1.684 0 00-.188.805c0 .302.06.573.18.813.125.234.302.419.531.554.235.13.498.196.79.196.296 0 .56-.066.788-.196a1.38 1.38 0 00.54-.554c.124-.24.187-.51.187-.813 0-.302-.063-.57-.188-.805a1.33 1.33 0 00-.539-.546 1.522 1.522 0 00-.789-.204z","fill":"currentColor"}})])
          )
        }
      }
    